/**
 * @class
 * @constructor
 */
function WebForwardLauncher() {
    this.getViews = function() {
        return [];
    };

    this.launchResource = function(resource, controller, launchToken) {
        if (launchToken) {
            window.open("/sslvpn_api/authentication/launch?token=" + launchToken);
        } else {
            window.open("/" + resource.id + "/" + resource.launch_url);
        }
    };
}

module.exports = WebForwardLauncher;